<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :searchFields="fields"
                    :repository="repositories.cid"
                    :validations="validations.id"
                    label="CID10"
                    v-model="data.model.cid"
                >
                    <template v-slot:itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        fields() {

            return [
                { key: 'codigo', searchable: true },
                { key: 'nome', searchable: true },
            ]
        },
        validations() {
            return {
                id: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid')
        }
    },
    filters: {
        ...formats,
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
    },
}
</script>